import { useTranslation, Trans } from "react-i18next";
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import sw1k1 from '../../img/Sponsorship/sw1k1.png';
import sw1k2 from '../../img/Sponsorship/sw1k2.png';
import sw1k3 from '../../img/Sponsorship/sw1k3.png';
import sw1k4 from '../../img/Sponsorship/sw2k1.png';
import sw2k1 from '../../img/Sponsorship/sw2k1.png';
import sw2k2 from '../../img/Sponsorship/sw2k2.png';
import sw2k3 from '../../img/Sponsorship/sw2k3.png';
import sw2k4 from '../../img/Sponsorship/sw2k4.png';
import sw3k1 from '../../img/Sponsorship/sw3k1.png';
import sw3k2 from '../../img/Sponsorship/sw3k2.png';
import sw3k3 from '../../img/Sponsorship/sw3k3.png';
import sw3k4 from '../../img/Sponsorship/sw3k4.png';

function Swiperr () {

    const { t } = useTranslation();

    const slides = [
        {
            title: t('sponsor.4'),
            subtitle: t('sponsor.5'),
            img1: sw1k1,
            img2: sw1k2,
            img3: sw1k3,
            img4: sw1k4,
        },
        {
            title: t('sponsor.6'),
            subtitle: t('sponsor.7'),
            img1: sw2k1,
            img2: sw2k2,
            img3: sw2k3,
            img4: sw2k4,
        },
        {
            title: t('sponsor.8'),
            subtitle: t('sponsor.9'),
            img1: sw3k1,
            img2: sw3k2,
            img3: sw3k3,
            img4: sw3k4,
        },
    ];

    const prevRef = useRef(null);
    const nextRef = useRef(null);

    return(
        <div className="overflow-hidden relative z-50">
            <div className="w-full h-[40px] xl:h-[60px] bg-[#131313]"></div>
            <div className="w-full h-[40px] xl:h-[60px] rounded-t-[40px] xl:rounded-t-[60px] bg-white mt-[-40px] xl:mt-[-60px]"></div>
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[60px] xl:mt-[80px]">
                <div className="xl:w-[1170px] mx-auto">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        slidesPerView={1}
                        spaceBetween={20}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                        }}
                        onBeforeInit={(swiper) => {
                            swiper.params.navigation.prevEl = prevRef.current;
                            swiper.params.navigation.nextEl = nextRef.current;
                        }}
                    >
                        {slides.map((slide, index) => (
                            <SwiperSlide key={index}>
                                <div className="flex flex-col md:flex-row justify-center gap-[20px]">
                                    <div className="relative">
                                        <img src={slide.img1} alt="" className="w-full"/>
                                        <div className="absolute left-[20px] bottom-[20px]">
                                            <p className="manrope text-[20px] xl:text-[32px] leading-[1.2] text-[#FFFFFF] font-[500]">{slide.title}</p>
                                            <p className="roboto text-[12px] xl:text-[14px] text-[#FFFFFFB2] font-[300] mt-[12px]">{slide.subtitle}</p>
                                        </div>
                                    </div>
                                    <div className="flex flex-col">
                                        <img src={slide.img2} alt="" />
                                        <div className="flex flex-wrap mt-[20px] gap-[20px]">
                                            <img src={slide.img3} alt="" className="w-[169px] flex-grow xl:w-[290px] xl:h-[218px]"/>
                                            <img src={slide.img4} alt="" className="w-[154px] flex-grow xl:w-[265px] xl:h-[218px]"/>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="flex justify-between mt-[20px] xl:mt-0 xl:absolute top-[180px] z-50 xl:w-[1220px]">
                    <button ref={prevRef} className="w-[50px] h-[50px] hover:scale-[0.9] transition-all flex items-center justify-center rounded-full bg-white">
                        <svg xmlns="http://www.w3.org/2000/svg" width ="42" height="42" viewBox="0 0 42 42" fill="none">
                            <rect x="42" y="42" width="42" height="42" rx="21" transform="rotate(-180 42 42)" fill="#17171F"/>
                            <path d="M29.6465 21L12.3524 21" stroke="white" stroke-width="1.10526" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M21 29.6475L12.3529 21.0004L21 12.3533" stroke="white" stroke-width="1.10526" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <button ref={nextRef} className="w-[50px] h-[50px] hover:scale-[0.9] transition-all flex items-center justify-center rounded-full bg-white">
                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                            <rect x="7.34351e-06" width="42" height="42" rx="21" fill="#17171F"/>
                            <path d="M12.3535 21L29.6476 21" stroke="white" stroke-width="1.10526" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M21 12.3525L29.6471 20.9996L21 29.6467" stroke="white" stroke-width="1.10526" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>      
        </div>
    );
}

export default Swiperr;